/** @jsxImportSource ../i18n */
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { ArrowRight, Lock, Mail } from 'lucide-react';
import { login, clearError } from '../store/slices/authSlice';
import { useRegistrationOpen } from '../services/authOptions';
import { AuthLayout } from '../components/shell/AuthLayout';
import { Banner, Button, Field, Input } from '../components/ui';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.auth);
  const [formData, setFormData] = useState({ email: '', password: '' });
  const registrationOpen = useRegistrationOpen();

  useEffect(() => {
    dispatch(clearError());
  }, [dispatch]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(login(formData));
    if (login.fulfilled.match(result)) {
      navigate('/dashboard');
    }
  };

  return (
    <AuthLayout>
      <h2 className="font-display text-display-md font-normal text-fg">Bon retour</h2>
      <p className="mt-2 text-[15px] text-fg-muted">Connectez-vous pour accéder à votre patrimoine.</p>

      {error && <Banner tone="loss" role="alert" className="mt-6">{error}</Banner>}

      <form onSubmit={handleSubmit} className="mt-8 space-y-5">
        <Field label="Adresse email" htmlFor="login-email">
          <Input
            id="login-email"
            type="email"
            autoComplete="email"
            leadingIcon={Mail}
            value={formData.email}
            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
            placeholder="vous@exemple.fr"
            required
          />
        </Field>
        <Field label="Mot de passe" htmlFor="login-password">
          <Input
            id="login-password"
            type="password"
            autoComplete="current-password"
            leadingIcon={Lock}
            value={formData.password}
            onChange={(e) => setFormData({ ...formData, password: e.target.value })}
            placeholder="••••••••"
            required
          />
        </Field>
        <div className="flex justify-end">
          <Link to="/reset-password" className="text-sm font-medium text-gold-300 transition-colors hover:text-gold-200">
            Mot de passe oublié ?
          </Link>
        </div>
        <Button type="submit" size="lg" fullWidth loading={loading} trailingIcon={ArrowRight}>
          Se connecter
        </Button>
      </form>

      {registrationOpen && (
        <p className="mt-8 text-center text-sm text-fg-muted">
          Pas encore de compte ?{' '}
          <Link to="/register" className="font-medium text-gold-300 transition-colors hover:text-gold-200">
            Créer un compte
          </Link>
        </p>
      )}
    </AuthLayout>
  );
};

export default Login;
